
import { useProfile } from "@/contexts/ProfileContext";
import { TestCreationCenter } from "@/components/dashboard/TestCreationCenter";
import { CandidateDashboard } from "@/components/dashboard/CandidateDashboard";
import { Loader2 } from "lucide-react";

const Dashboard = () => {
  const { profile, isLoading: profileIsLoading } = useProfile();
  
  console.log(`[Dashboard] Rendering. Profile Role: ${profile?.role}, Profile IsLoading: ${profileIsLoading}`);

  // If ProfileContext says it's loading, Dashboard should reflect that
  if (profileIsLoading && !profile) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader2 className="h-10 w-10 animate-spin text-foreground" />
        <p className="ml-2">Loading Dashboard Data...</p>
      </div>
    );
  }

  if (!profile?.role) {
    console.warn("[Dashboard] Profile loaded but no role. This shouldn't typically happen here if MainLayout is correct.");
    return (
      <div className="container text-center py-10">
        <p>Cannot determine user role for dashboard.</p>
      </div>
    );
  }

  // Render appropriate dashboard based on user role
  if (profile.role === 'employer') {
    return <TestCreationCenter />;
  }

  if (profile.role === 'candidate') {
    return <CandidateDashboard />;
  }

  // Fallback for unknown roles
  return (
    <div className="container text-center py-10">
      <p>Unknown user role: {profile.role}</p>
    </div>
  );
};

export default Dashboard;
